(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["future-legacy-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.flExperience) return;
  window.flExperience = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  let preference = null;
  try { preference = localStorage.getItem('ironfather-motion'); } catch {}
  let enabled = false, pending = 0;
  const visible = new Set();
  const ready = new WeakSet();
  const panelsReady = new WeakSet();
  const inView = new IntersectionObserver(entries => {
    for (const e of entries) {
      e.target.classList.toggle('fl-in-view',e.isIntersecting);
      if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
    }
    schedule();
  });
  function schedule() {
    if (pending || !enabled || document.hidden) return;
    pending = requestAnimationFrame(() => {
      pending = 0;
      if (!enabled) return;
      for (const el of visible) {
        if (!el.isConnected) { visible.delete(el);inView.unobserve(el);continue; }
        if (!el.hasAttribute('data-fl-parallax')) continue;
        const r = el.getBoundingClientRect();
        const progress = Math.max(-1,Math.min(1,(innerHeight/2-r.top-r.height/2)/(innerHeight/2+r.height/2)));
        el.style.setProperty('--fl-travel',`${progress*14}px`);
      }
    });
  }
  function update() {
    enabled = !reduced.matches && preference !== 'off';
    document.documentElement.classList.toggle('fl-motion-enabled',enabled);
    document.documentElement.classList.toggle('fl-reduced-motion',!enabled);
    document.querySelectorAll('[data-fl-toggle]').forEach(b => {
      b.hidden = false;
      b.disabled = reduced.matches;
      b.textContent = enabled ? b.dataset.on : b.dataset.off;
      b.setAttribute('aria-pressed',String(enabled));
      if (reduced.matches) b.title=b.dataset.system; else b.removeAttribute('title');
    });
    if (!enabled) {
      cancelAnimationFrame(pending);pending=0;
      document.querySelectorAll('.fl-depth-surface').forEach(el => ['--fl-rx','--fl-ry','--fl-travel'].forEach(k=>el.style.removeProperty(k)));
    }
    schedule();
  }
  function init(root = document) {
    root.querySelectorAll('[data-fl-depth],.product-media:has(> .product-media__image)').forEach(el => {
      if (ready.has(el) || el.closest('dialog,.zoom-dialog')) return;
      ready.add(el);el.classList.add('fl-depth-surface');
      let frame=0;
      el.addEventListener('pointermove',e => {
        if (!enabled || !fine.matches || e.pointerType==='touch') return;
        cancelAnimationFrame(frame);
        frame=requestAnimationFrame(() => {
          if (!enabled) return;
          const r=el.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
          el.style.setProperty('--fl-rx',`${(.5-y)*5}deg`);
          el.style.setProperty('--fl-ry',`${(x-.5)*7}deg`);
          const room=el.closest('[data-fl-showroom]');
          if(room){room.style.setProperty('--fl-light-x',`${x*100}%`);room.style.setProperty('--fl-light-y',`${y*100}%`);}
        });
      });
      el.addEventListener('pointerleave',() => {
        cancelAnimationFrame(frame);el.style.removeProperty('--fl-rx');el.style.removeProperty('--fl-ry');
      });
      if(el.hasAttribute('data-fl-parallax')) inView.observe(el);
    });
    root.querySelectorAll('[data-fl-showroom]').forEach(room => {
      if(panelsReady.has(room))return;
      panelsReady.add(room);inView.observe(room);
      const buttons=[...room.querySelectorAll('[data-fl-select]')];
      const panels=[...room.querySelectorAll('[data-fl-panel]')];
      let current=0,start=null;
      const select=index=>{
        current=index;
        buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
        panels.forEach((p,i)=>p.hidden=i!==index);
      };
      buttons.forEach((b,i)=>{
        b.addEventListener('click',()=>select(i));
        b.addEventListener('keydown',e=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
          e.preventDefault();
          const next=e.key==='Home'?0:e.key==='End'?buttons.length-1:(i+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
          select(next);buttons[next].focus();
        });
      });
      room.addEventListener('touchstart',e=>{
        if(e.target.closest('a,button'))return;
        start={x:e.touches[0].clientX,y:e.touches[0].clientY};
      },{passive:true});
      room.addEventListener('touchend',e=>{
        if(!start)return;
        const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;
        if(Math.abs(dx)>65 && Math.abs(dx)>Math.abs(dy)*1.5)select((current+(dx<0?1:-1)+buttons.length)%buttons.length);
        start=null;
      },{passive:true});
      room.addEventListener('touchcancel',()=>start=null,{passive:true});
    });
  }
  document.addEventListener('click',e=>{
    if(!e.target.closest('[data-fl-toggle]'))return;
    preference=enabled?'off':'on';
    try{localStorage.setItem('ironfather-motion',preference);}catch{}
    update();
  });
  document.addEventListener('shopify:section:load',()=>{init();update();});
  document.addEventListener('shopify:block:select',e=>{
    const panel=e.target.closest('[data-fl-panel]');
    if(panel){const button=document.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);button?.click();}
  });
  let mutationsPending=false;
  const mutations=new MutationObserver(records=>{
    if(mutationsPending || !records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))return;
    mutationsPending=true;
    requestAnimationFrame(()=>{mutationsPending=false;init();});
  });
  mutations.observe(document.querySelector('#MainContent') || document.body,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>{document.documentElement.classList.toggle('fl-motion-suspended',document.hidden);schedule();});
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  reduced.addEventListener('change',update);
  init();update();
})();
  } catch(e) { console.error(e); }
})();

})();
